export const skills = [
  'CSS3',
  'HTML5',
  'JavaScript',
  'TypeScript',
  'React',
  'Next.js',
  'Redux',
  'RTK Query',
  'Node.js',
  'Nest.js',
  'MongoDB',
  'MySQL',
  'TypeORM',
  'JWT',
  'SASS',
  'Styled Component',
  'Material UI',
  'Rest Api',
  'Webpack',
  'Parcel',
  'Git',
  'React Native',
  'Axios',
  'Express',
  'Swagger',
  'Cron',
  'Formik',
  'React Hook Form',
  'Yup',
  'i18next',
  'Responsible/ Adaptive layout',
];
